import styled from "styled-components";
import colors from "../../../../config/colors";
import { isMobile } from "../../../../utils/common";

export const DashboardContainer = styled.div`
  background-color: ${colors.darkBackground};
  position: fixed;
  top: 0px;
  left: 50px;
  height: 100vh;
  width: calc(100vw - 50px);
  ${isMobile() &&
  `
    left:0px;
    width: 100vw;
    position: static;
    height:fit-content;
  `}
`;
